"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateNumber = exports.splitToDigits = exports.trimRight = exports.trimLeft = void 0;
const type_1 = require("./type");
function trimLeft(str, char) {
    if (str === '') {
        return '';
    }
    let pos = 0;
    while (str[pos] === char[0]) {
        pos++;
    }
    return str.substring(pos);
}
exports.trimLeft = trimLeft;
function trimRight(str, char) {
    if (str === '') {
        return '';
    }
    let lastPos = str.length - 1;
    while (str[lastPos] === char[0]) {
        lastPos--;
    }
    return str.substring(0, lastPos + 1);
}
exports.trimRight = trimRight;
function splitToDigits(str) {
    return str.split('').map((digit) => parseInt(digit));
}
exports.splitToDigits = splitToDigits;
function validateNumber(value) {
    // String type in TS maybe number at runtime
    switch (typeof value) {
        case 'string': {
            return value;
        }
        case 'bigint': {
            // BigInt is integer, not float
            return value.toString();
        }
        case 'number': {
            throw new type_1.InvalidFormatError();
            /**
             * SOME NUMBERS MAY CAUSE ERRORS
             * - Loss precision
             * 		Number.isInteger(value) && !Number.isSafeInteger(value)
             * - Cannot parse in scientific notation
             * 		value.toString().includes('e')
             */
        }
        case 'object': {
            // Check for nullable strings
            if (value === null) {
                throw new type_1.InvalidFormatError();
            }
            return value.toString();
        }
        default: {
            // Typeof is undefined, boolean, symbol, function
            throw new type_1.InvalidFormatError();
        }
    }
}
exports.validateNumber = validateNumber;
